import { render, staticRenderFns } from "./producer_edit_cider_form.vue?vue&type=template&id=3960a85e&scoped=true"
import script from "./producer_edit_cider_form.vue?vue&type=script&lang=js"
export * from "./producer_edit_cider_form.vue?vue&type=script&lang=js"
import style0 from "./producer_edit_cider_form.vue?vue&type=style&index=0&id=3960a85e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960a85e",
  null
  
)

export default component.exports